import React from 'react';

import SimpleTooltip from 'components/Tooltips/SimpleTooltip';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, SimpleTooltipContainer, ToolTip } from './styles';

export interface Props {
  content?: string | JSX.Element;
  messageKey?: string;
  htmlFor?: string;
  onClick?: () => void;
  [key: string]: any;
  tooltip?: boolean;
  simpleTooltip?: boolean;
  simpleTooltipText?: string;
  tooltipClassName?: string;
  tooltipClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

const Label = ({
  content,
  messageKey,
  tooltip,
  tooltipClick,
  tooltipClassName,
  simpleTooltip,
  simpleTooltipText,
  ...rest
}: Props) => {
  const { t } = useStoreTranslation();
  return (
    <Container>
      <label {...rest}>
        {messageKey ? t(messageKey) : content}
        {tooltip && (
          <ToolTip className={tooltipClassName} src="/corporate/images/advice-2.svg" alt="tooltip" onClick={tooltipClick} />
        )}
      </label>
      {simpleTooltip && (
        <SimpleTooltipContainer>
          <SimpleTooltip idTooltip={`tooltip-${Math.random().toString(36).substring(7)}`} text={simpleTooltipText} />
        </SimpleTooltipContainer>
      )}
    </Container>
  );
};

export default Label;
